/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { VApplication } from "../application";
import { LIST_ASSETS } from "../pages/ListedAssets/graphql/listed-assets.query";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import {TEST_DATA } from "./config/assets-test-data"
import {useAsset} from "../pages/ListedAssets/provider"
import {SOUND , VIDEO} from "../assets"

const MODULE_NAME = "ListedAssetsService";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

interface IProps{
    imageServer:any
}

export class ListedAssetsService {
    private static instance: ListedAssetsService;
    private vapp: VApplication;
    private imageServer;
    private constructor(props: IProps | any = {}) {
        this.vapp = VApplication.getInstance();
        this.imageServer = props?.imageServer
      
    }

    
    public static getInstance(props: IProps | any = {}): ListedAssetsService {
        if (!ListedAssetsService.instance) {
            ListedAssetsService.instance = new ListedAssetsService(props);
        }
        return ListedAssetsService.instance;
    }

 
    async getAssets(size: number, offset: number) {
        const getassetsService = ListedAssetsService.getInstance();
        const{ id}= useAsset();
        console.log("storeid-listed-service",getassetsService.imageServer)
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        try {
            if (client) {
                const res = await client.query({
                    query: LIST_ASSETS,
                    variables: {
                        size: size,
                        offset: offset,
                        filter: {
                            state:["listed"],
                            store:id
                          }
                    },
                    fetchPolicy:'network-only'
                });
                log.success(MODULE_NAME, "get assets result: ", res);
              if(res){
                    let _data= res?.data?.getAssets?.data;
                    log.success(MODULE_NAME, "listed assets ", _data);

                    
                    let results = _data?.map((item:any)=>{

                        const imgUrl = item?.img;
                        const urlFormat = imgUrl?.replace(/^.*\/\/[^\/]+/, '');
                        const imgBBformat = imgUrl?.split('/');
                        const ibbFormat = imgBBformat[imgBBformat.length-3]

                        let _img;
                        if(ibbFormat === "i.ibb.co"){
                        //    _img =`${getassetsService.imageServer}/imgbb${urlFormat}/:/rs=h:500`
                        _img = item?.img
                        
                        } 
                        else {
                            _img = item?.img
                            // _img = `${getassetsService.imageServer}${urlFormat}/:/rs=h:500`
                        }
                         console.log("mui",_img)

                         if(item?.type === "audio"){
                            _img = item?.thumbnail ?? SOUND
                        }
                        if(item?.type === "video"){
                            _img = item?.thumbnail ?? SOUND
                        }
                    


                        return({
                            ...item,
                            price: item?.price?.map(item=>{
                                if(item?.type==='fiat'){
                                    return({
                                        ...item,
                                        locale: 'en-US',
                                    })
                                }
                                else{
                                    return({
                                        ...item,
                                        amount:(item?.amount)?.toFixed(3)
                                    })
                                }
                            }),
                            img:_img,
                            storeId:id,
                            tag: null,
                            networkType:null,
                            // category: item?.tag?.toLowerCase(),
                            tokenId:item?.serialNo,
                            serialNo:`Rare #/${item?.serialNo}`,
                            subtitle:item?.subtitle.replace(/<[^>]*>?/gm, ''),
                            audioDetail: item?.type === "audio" ? true : false,
                            videoDetail: item?.type === "video" ? true : false,
                        })
                    })
                    return{
                        pagination: {
                            nextOffset: offset + res?.data?.getAssets?.pageSize,
                            totalItems: res?.data?.getAssets?.totalCount
                        },  
                        results
                    }
                }
            }
        } catch (err) {
            log.error(MODULE_NAME, "error in get assets", err);
            // throw Error(`${err?.message}`)
            return {
                pagination: {
                    nextOffset: 0,
                    totalItems: 0,
                },
                results: [],
            };
        }
    }
}
